import axiosInstance from "./api_helper";

const categoryService = {
    
    list: async () => {
        return axiosInstance.get(`/api/categories/list`);
    },
    create: async (payload) => {
        return await axiosInstance.post('/api/categories', payload);
    },
    update: async (payload) => {
        return axiosInstance.put(`/api/categories/${payload.id}`, JSON.stringify(payload.data));
    },
    delete: async (id) => {
        return axiosInstance.delete(`/api/categories/${id}`);
    },
};

export default categoryService;